const l10n:FooterL10n =  {
  "linkList": {
    "companyLink": "Hakkımızda",
    "termsOfService": "Kullanım Şartları",
    "privacyPolicy": "Gizlilik İlkesi",
    "guaranteeOfRights": "Veri Sahiplerinin Hakkı",
    "customerSupport": "DESTEK",
    "cookiePolicy": "Çerez İlkesi",
    "declarationOfSafety": "Güvenlik・Emniyet Duyurusu",
    "youthProtectionPolicy": "Gençleri Koruma İlkesi",
    "communityPolicy": "Topluluk İlkesi",
    "probability": "probability",
    "operationPolicy": "İşleyiş İlkesi",
    "doNotSell": "Kişisel Bilgilerimi Satmayın",
    "gameGrade": "게임이용등급",
    "communityPolicyView": "커뮤니티정책",
    "servicePolicy": "서비스정책",
    "termsOfUse": "회원정책",
    "operationPolicyNCJ": "운영방침",
    "reportRightsInfringement": "권리침해신고",
    "ncPrivacyCenter": "NC Privacy Center",
    "commercialTransactions": "특정상거래법에 의거한 표기",
    "settlementFund": "자금결제법에 따른 표시",
    "serviceTerm": "서비스 이용약관",
    "legalDocumentation": "Legal Documentation",
    "googleAPIDisclosure": "Google API Disclosure",
    "report": "신고하기",
    "serviceConsent": "NC Hizmet Onayı",
    "careers": "Careers",
    "termsOfMobile": "모바일게임 약관"
  },
  "footerWords": {
    "gameRelatedLaw": "Oyun Yasalarına Dair İlave Bilgi",
    "brandInformation": "Şirket Adı Bilgisi",
    "copyright": "Telif Hakkı",
    "channelingInfo": "NC, elektronik ticaret yoluyla Plaync üzerinden oyunları yönlendiren bir komisyoncudur ve bahsedilen oyunların bir satış ortağı değildir.<br>Sunulan oyunlarla ilgili tüm zorunluluklar ve sorumluluklar; şahsi e-ticaret ortağının yükümlülüğündedir. Onlarla ilişkili sorunlarda sorumlu taraf biz değiliz."
  },
  "infoCS": {
    "businessInformation": "İşletme Bilgilerini Görüntüle",
    "infoAddress": "Şirket Adı: NC Corporation;  Eş-CEO'lar Kim Taek-Jin, Park Byung-Moo; İşletme Sicil Numarası: 220-81-43000; E-commerce Registration: 2026-Seongnam Bundang A-0316",
    "infoAddressNCV": "9 RAFFLES PLACE #26-01 REPUBLIC PLAZA SINGAPORE (048619)",
    "mobile": "Adres: 12, Daewangpangyo-ro 644beon-gil, Bundang-gu, Seongnam-si, Gyeonggi-do, Kore Cumhuriyeti. Müşteri DESTEK: +82 1600-0020. Fax: +82 02-2186-3550.",
    "pc": "Adres: 12, Daewangpangyo-ro 644beon-gil, Bundang-gu, Seongnam-si, Gyeonggi-do, Kore Cumhuriyeti. Müşteri DESTEK: +82 1600-0020. Fax: +82 02-2186-3550.",
    "ncfamilyzone": "Adres: 12, Daewangpangyo-ro 644beon-gil, Bundang-gu, Seongnam-si, Gyeonggi-do, Kore Cumhuriyeti. Müşteri DESTEK: +82 1600-0020. Fax: +82 02-2186-3550.",
    "other": "Adres: 12, Daewangpangyo-ro 644beon-gil, Bundang-gu, Seongnam-si, Gyeonggi-do, Kore Cumhuriyeti. Müşteri DESTEK: +82 1600-0020. Fax: +82 02-2186-3550.",
    "none": "",
    "infoEmail": "E-posta",
    "infoEmail-mobile": "MobileCS@ncsoft.com",
    "infoEmail-pc": "credit@ncsoft.com",
    "infoEmail-ncfamilyzone": "ncfamilyzone@ncsoft.com",
    "infoEmail-other": "credit@ncsoft.com/(PC Game)/MobileCS@ncsoft.com/(Mobile Game)",
    "infoEmail-none": ""
  },
  "infoJP": {
    "jpTitle": "Başlık",
    "jpGenre": "Tür",
    "jpPrice": "Fiyat",
    "jpPriceValue": "Oynaması Ücretsiz (Uygulama içi satın alımlar sunar)",
    "jpOs": "Desteklenen İS",
    "jpPlatform": "Platform",
    "jpDevelopedBy": "Geliştirici/Yayıncı",
    "jpReleaseDay": "Çıkış Tarihi",
    "jpReleaseDayValue_LW": "4 Kasım 2021"
  },
  "country": {
    "KR": "Kore Cumhuriyeti",
    "TW": "Tayvan",
    "RU": "Rusya",
    "MY": "Malezya",
    "SA": "Suudi Arabistan",
    "SG": "Singapur",
    "AE": "Birleşik Arap Emirlikleri",
    "ID": "Endonezya",
    "JP": "Japonya",
    "QA": "Katar",
    "TH": "Tayland",
    "PH": "Filipinler",
    "HK": "Hong Kong",
    "UA": "Ukrayna",
    "BY": "Belarus",
    "LT": "Litvanya",
    "PL": "Polonya",
    "GR": "Yunanistan",
    "IL": "İsrail",
    "KW": "Kuveyt",
    "AT": "Avusturya",
    "US": "Amerika Birleşik Devletleri",
    "CA": "Kanada",
    "DE": "Almanya",
    "GB": "Birleşik Krallık",
    "FR": "Fransa",
    "BR": "Brezilya",
    "IT": "İtalya",
    "ES": "İspanya",
    "CL": "Şili",
    "NO": "Norveç",
    "SE": "İsveç",
    "IE": "İrlanda",
    "PT": "Portekiz",
    "FI": "Finlandiya",
    "DK": "Danimarka",
    "CH": "İsviçre",
    "AR": "Arjantin",
    "PE": "Peru",
    "MX": "Meksika",
    "KZ": "Kazakistan",
    "UZ": "Özbekistan",
    "AZ": "Azerbaycan",
    "GE": "Gürcistan",
    "MD": "Moldova",
    "AM": "Ermenistan",
    "MO": "Makao",
    "IN": "Hindistan",
    "PK": "Pakistan",
    "NL": "Hollanda",
    "RO": "Romanya",
    "AU": "Avustralya",
    "TR": "Türkiye",
    "EC": "Ekvador",
    "CO": "Kolombiya",
    "ZA": "Güney Afrika",
    "EG": "Mısır",
    "NC": "Küresel"
  }
};

export default l10n;
